module.exports = __webpack_public_path__ + "arrow_left.11911410dca2de148f30.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/img/svg/arrow_left.svg
// module id = ../../../../angular-bootstrap-md/img/svg/arrow_left.svg
// module chunks = 3